import { PillarSlug } from '@/types';

/**
 * Sistema de Normalização de Pilares
 * 
 * Converte nomes antigos de pilares para os novos padrões:
 * - saude → saudavel
 * - carreira → profissional
 * - relacionamentos → social
 * - espiritualidade → espiritual
 */

const PILLAR_NAME_MAP: Record<string, PillarSlug> = {
  // Nomes antigos → novos
  'saude': 'saudavel',
  'carreira': 'profissional',
  'relacionamentos': 'social',
  'espiritualidade': 'espiritual',
  
  // Nomes já corretos (passthrough)
  'saudavel': 'saudavel',
  'profissional': 'profissional',
  'social': 'social',
  'sentimental': 'sentimental',
  'espiritual': 'espiritual',
  'interior': 'interior',
};

/**
 * Normaliza um nome de pilar para o padrão atual
 */
export function normalizePillarName(pillar: string | undefined | null): PillarSlug {
  if (!pillar) return 'interior'; // Default fallback
  
  const normalized = PILLAR_NAME_MAP[pillar.toLowerCase()];
  
  if (!normalized) {
    console.warn(`⚠️ Nome de pilar desconhecido: "${pillar}", usando fallback "interior"`);
    return 'interior';
  }
  
  return normalized;
}

/**
 * Normaliza um array de nomes de pilares
 */
export function normalizePillarArray(pillars: string[] | undefined | null): PillarSlug[] {
  if (!pillars || pillars.length === 0) return ['interior'];
  
  return pillars
    .map(p => normalizePillarName(p))
    .filter((value, index, self) => self.indexOf(value) === index); // Remove duplicatas
}

/**
 * Verifica se um pilar está usando nome antigo
 */
export function isLegacyPillarName(pillar: string): boolean {
  return ['saude', 'carreira', 'relacionamentos', 'espiritualidade'].includes(pillar.toLowerCase());
}
